import { MobileMetricCard } from '@/components/base/MobileUi';
import type { AdvanceRequest } from '@/types';
import { formatCurrencyCompact } from '@/utils/format';

export default function LoanStats({ loans }: { loans: AdvanceRequest[] }) {
  const pending = loans.filter((loan) => loan.status === 'Chờ kiểm tra').length;
  const approved = loans.filter((loan) => ['Đã duyệt', 'approved_locked', 'Chờ giải ngân'].includes(loan.status));
  const disbursed = loans.filter((loan) => ['Đã giải ngân', 'disbursed'].includes(loan.status));
  const totalDisbursed = disbursed.reduce((sum, loan) => sum + loan.soTien, 0);

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      <MobileMetricCard label="Chờ duyệt" value={pending} caption="Yêu cầu mới" tone="amber" icon="ri-time-line" />
      <MobileMetricCard label="Chờ giải ngân" value={approved.length} caption="Đã hoàn tất phê duyệt" tone="sky" icon="ri-hourglass-line" />
      <MobileMetricCard label="Đã giải ngân" value={disbursed.length} caption="Khoản vay đang ghi nhận" tone="emerald" icon="ri-checkbox-circle-line" />
      <MobileMetricCard label="Tổng giải ngân" value={formatCurrencyCompact(totalDisbursed)} caption="Giá trị đã chuyển nông hộ" tone="teal" icon="ri-hand-coin-line" />
    </div>
  );
}
